import * as React from 'react';
import { DARK_PLACEHOLDER, getNewValue } from '../../../../constants';
import Icon from '../../../../widgets/Icons';
import InputDropdown from '../../../../widgets/InputDropdown';
import { DATA_DIRECTIONS } from '../data_constants';
import { FilterDropdownProps } from './AdditionalFilterBar';
import { OptionType } from '../../../../types';
import { ValueType } from 'react-select/src/types';
import LightTooltip, {
  TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE,
} from '../../../../widgets/LightTooltip';

const DIRECTIONS = [
  { value: DATA_DIRECTIONS.BOTH, label: 'Either direction' },
  { value: DATA_DIRECTIONS.INBOUND, label: 'Inbound' },
  { value: DATA_DIRECTIONS.OUTBOUND, label: 'Outbound' },
];

export default class DirectionDropdown extends React.Component<FilterDropdownProps> {
  handleSelectChange = (value: ValueType<OptionType>) => {
    const v = getNewValue(value, false);
    this.props.setFilter(this.props.filterKey, v && v.value);
  };

  render() {
    const value = this.props.value || '';
    const direction = DIRECTIONS.find((dir) => dir.value === value);
    return (
      <div className="pt-3" style={{ minWidth: '150px' }}>
        <h5>
          Direction Initiated
          <LightTooltip
            size="xl"
            tooltip={
              <table>
                <tr>
                  <td className="px-3">
                    <strong>Inbound:</strong>
                  </td>
                  <td>
                    Connection is initiated from an external host into network
                  </td>
                </tr>
                <tr>
                  <td className="px-3">
                    <strong>Outbound:</strong>
                  </td>
                  <td>
                    Internal host initiates outbound connection from network
                  </td>
                </tr>
              </table>
            }
            delay={TOOLTIP_DELAY_INSTANT_SHOW_INSTANT_HIDE}
            placement="top"
          >
            <Icon.Question className="ml-2 text-muted" />
          </LightTooltip>
        </h5>

        <InputDropdown
          isCreatable={false}
          onChange={this.handleSelectChange}
          options={DIRECTIONS}
          placeholder="Any direction"
          value={direction}
          styles={DARK_PLACEHOLDER}
        />
      </div>
    );
  }
}
